import React, { useState } from "react";
import axios from "axios";
import { MailCheck, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SNOOZE_DAYS = 3;

// Мягкое напоминание о подтверждении email: вход не блокируется,
// баннер можно скрыть на 3 дня (снуз индивидуален для каждого пользователя).
export const EmailVerifyBanner = ({ user, showToast }) => {
  const snoozeKey = `rv_email_verify_snoozed_at_${user?.id || "anon"}`;
  const [hidden, setHidden] = useState(() => {
    try {
      const ts = parseInt(localStorage.getItem(snoozeKey) || "0", 10);
      return !!ts && Date.now() - ts < SNOOZE_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  });
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || hidden) return null;

  const resend = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/auth/resend-verification`);
      showToast(res.data?.message || `Письмо отправлено на ${user.email}`, "success");
    } catch (e) {
      showToast(e.response?.data?.detail || "Не удалось отправить письмо, попробуйте позже", "error");
    } finally {
      setSending(false);
    }
  };

  const dismiss = () => {
    try {
      localStorage.setItem(snoozeKey, String(Date.now()));
    } catch (e) {}
    setHidden(true);
  };

  return (
    <div className="w-full max-w-7xl mx-auto px-3 sm:px-6 pt-4" data-testid="email-verify-banner">
      <div
        className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl px-4 py-3"
        style={{ background: "rgba(13,148,136,0.08)", border: "1px solid rgba(13,148,136,0.25)" }}
      >
        <div className="flex items-start gap-3 flex-1">
          <MailCheck size={20} style={{ color: "var(--rv-teal, #0d9488)", flexShrink: 0, marginTop: 2 }} />
          <div>
            <p className="text-sm font-semibold" style={{ color: "#0f766e" }}>
              Подтвердите ваш email
            </p>
            <p className="text-xs sm:text-sm" style={{ color: "var(--rv-text-muted, #6b7280)" }}>
              Мы отправили письмо на {user.email}. Подтверждение нужно, чтобы вы гарантированно получали
              уведомления о заданиях и могли восстановить пароль.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:flex-shrink-0">
          <button
            onClick={resend}
            disabled={sending}
            className="px-3 py-1.5 text-xs sm:text-sm rounded-lg font-medium text-white disabled:opacity-60"
            style={{ background: "var(--rv-teal, #0d9488)" }}
            data-testid="email-verify-resend-btn"
          >
            {sending ? "Отправляем..." : "Отправить письмо повторно"}
          </button>
          <button
            onClick={dismiss}
            className="p-1.5 rounded-lg"
            style={{ color: "var(--rv-text-muted, #6b7280)" }}
            aria-label="Скрыть напоминание"
            data-testid="email-verify-dismiss-btn"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};
